
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import ShopImagesUpload from '@/views/shop/components/ShopImagesUpload.vue';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';

@Component({
  components: {
    ShopImagesUpload,
  },
})
export default class LookImagesModal extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Prop()
  sourceType!: any;

  @Prop({
    type: Array,
    default: () => [],
  })
  oldHeaderId!: [];

  title = '选择图片';

  deleType = true;

  total = 0;

  page = 1;

  lastPage = 0;

  loadType = false;

  lodoing = false;


  draftList = [];

  deleteKeys: any = [];

  form = {
    page: 1,
    pageSize: 10,
  };

  data: any = {
    edit: [],
    add: [],
    delete: [],
  };

  p_type: any = '';

  albumId: any = '';

  activeKey: any = '0';

  deleteObjs: any = [];

  @Ref('shopImagesUpload')
  shopImagesUpload!: ShopImagesUpload;

  init(name: string, type: any, data: any, albumId?: any) {
    this.title = name;
    this.p_type = type;
    this.visible = true;
    this.data = data;
    const { add, delete: del } = data;
    this.albumId = albumId;
    this.activeKey = '0';
    this.draftList = add || [];
    // this.selectedKeys = del;
    this.deleteObjs = del;
    this.selectedKeys = del.map((item: any) => item.resource_id);
    // this.listData = this.listDasssta;
    const params = {
      page: this.page,
      pageSize: 10,
      audit_status: this.activeKey !== '0' ? this.activeKey : '',
    };
    if (albumId) {
      this.getAlbumList(albumId, params);
    }
    if (this.sourceType === 'add') {
      this.activeKey = '5';
      this.listData = this.draftList;
    }
  }

  async getAlbumList(albumId: any, params: any) {
    const res = await this.brandService.brandAlbumKaTemplateAlbum(albumId, params);
    this.listData = [...this.listData, ...res.list];
    this.total = res.total;
    this.lodoing = false;
    this.lastPage = res.lastPage;
    if (params.page < res.lastPage) {
      this.loadType = true;
    } else {
      this.loadType = false;
    }
  }

  funDelete() {
    this.deleType = false;
  }

  /**
   * 同步状态
   */
  synStatus() {
    console.log('同步状态');
  }

  funTDelete() {
    this.deleType = true;
  }

  handleOk() {
    this.visible = false;
    this.data.delete = this.deleteObjs;
    this.data.add = this.draftList;
    this.$emit('submit', this.p_type, this.data);
    this.listData = [];
    this.draftList = [];
    this.selectedKeys = [];
    this.deleteObjs = [];
    this.page = 1;
    this.loadType = false;
    this.lodoing = false;
    this.lastPage = 1;
  }

  handleCancel() {
    this.visible = false;
    this.listData = [];
    this.total = 0;
    this.selectedKeys = [];
    this.activeKey = '0';
    this.page = 1;
    this.deleType = true;
  }

  uploadImage() {
    this.shopImagesUpload.init(this.title);
  }

  deleteImage() {
    this.draftKeys.forEach((element: any) => {
      this.draftList = this.draftList.filter((item: any) => item.resource_id !== element);
    });
    this.listData = this.draftList;
  }

  callback(key: string) {
    this.listData = [];
    this.activeKey = key;
    if (key === '5') {
      this.listData = this.draftList;
    } else {
      // this.listData = this.listDasssta;
      const params = {
        albumId: this.albumId,
        page: 1,
        pageSize: 10,
        status: key !== '0' ? key : '',
        // shopId: this.shopId,
      };
      if (this.albumId) {
        this.getAlbumList(this.albumId, params);
      }
    }
  }
  listData: any = [];
  listDasssta: any = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  draftKeys: any[] = [];
  handleCheck(key: any): void {
    if (this.activeKey === '5') {
      const index = this.draftKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.draftKeys.splice(index, 1);
      } else {
        // 未选中，加入
        this.draftKeys.push(key.resource_id);
      }
    } else {
      const index = this.selectedKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.selectedKeys.splice(index, 1);
        this.deleteObjs = this.deleteObjs.filter((item: any) => item.resource_id !== key.resource_id);
      } else {
        // 未选中，加入
        this.selectedKeys.push(key.resource_id);
        this.deleteObjs.push(key);
      }
    }
  }

  funSynch() {
    console.log('同步状态');
  }
  edit() {
    console.log('编辑');
  }
  dele() {
    console.log('删除');
  }
  lookReason() {
    console.log('查看失败原因');
  }
  changeImg(img: any) {
    this.activeKey = '5';
    if (this.activeKey === '5') {
      this.listData = img;
    }
    this.draftList = img;
  }
  onChange(page: string) {
    console.log(page);
  }

  delteItem(key: any) {
    this.selectedKeys.push(key.resource_id);
    this.deleteObjs.push(key);
  }
  cancelPage() {
    console.log('取消');
    if (this.activeKey === '5') {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.draftKeys.filter((item) => !idsToRemove.has(item));
      this.draftKeys = result;
    } else {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.selectedKeys.filter((item) => !idsToRemove.has(item));
      const deleteObjs = this.deleteObjs.filter((item: any) => !idsToRemove.has(item.resource_id));
      this.deleteObjs = deleteObjs;
      this.selectedKeys = result;
    }
  }
  loadMore() {
    this.page++;
    this.lodoing = true;
    const params = {
      page: this.page,
      pageSize: 10,
      audit_status: this.activeKey !== '0' ? this.activeKey : '',
    };
    if (this.albumId) {
      this.getAlbumList(this.albumId, params);
    }
  }
}
